import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: '', senha: '' });
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const upd = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault(); setErro(''); setLoading(true);
    try {
      const u = await login(form.email, form.senha);
      nav(u.tipo === 'admin' ? '/admin' : '/veiculos');
    } catch (err) {
      setErro(err.response?.data?.error || 'E-mail ou senha incorretos.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--ink)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 36, justifyContent: 'center' }}>
          <img src="/assets/heritage-logo-transparent.png" alt="Heritage" style={{ width: 48, height: 48, objectFit: 'contain' }} />
          <span style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, color: '#fff', fontWeight: 700 }}>Heritage BH</span>
        </Link>

        <div style={{ background: '#fff', borderRadius: 'var(--r-md)', padding: '36px 40px', boxShadow: 'var(--shadow-lg)' }}>
          <div style={{ marginBottom: 28 }}>
            <div className="eyebrow">Acesso</div>
            <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 26, fontWeight: 600 }}>Entrar na plataforma</h1>
          </div>

          {erro && <div className="alert alert-danger">{erro}</div>}

          <form onSubmit={submit}>
            <div className="form-group"><label>E-mail</label><input name="email" type="email" value={form.email} onChange={upd} required autoFocus /></div>
            <div className="form-group"><label>Senha</label><input name="senha" type="password" value={form.senha} onChange={upd} required /></div>
            <div style={{ textAlign: 'right', marginBottom: 22 }}>
              <Link to="/recuperar-senha" style={{ fontSize: 12, color: 'var(--rust)', fontWeight: 700, letterSpacing: .5 }}>Esqueci minha senha</Link>
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', minHeight: 50 }} disabled={loading}>
              {loading ? 'Entrando…' : 'Entrar'}
            </button>
          </form>

          <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--ink-muted)', marginTop: 24 }}>
            Não tem conta?{' '}
            <Link to="/cadastro" style={{ color: 'var(--rust)', fontWeight: 900 }}>Criar conta grátis</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
